
























































import { Component, Vue } from "vue-property-decorator";

@Component
export default class DownloadArea extends Vue {
  loading = false;

  menu = [
    {
      title: "1. Scarica Dati aggregati in csv/xls",
      subtitle: "",
      to: "/download-csv-xls",
      type: "",
    },
  ];

  onSurveyTypeClick(to: string, type = "") {
    if (type !== "link") {
      this.$router.push(to).catch(error => console.log(error));
    } else {
      window.open(to, "_blank");
    }
  }
}
